export class Sinusoid {
    constructor({ numAxes, periods, axisRandomization = true, speed = 1, speedRandomization = true }) {
        this.offsets = [];
        this.periods = [];
        this.weights = [];
        this.speeds = [];
        this.xCoefficients = [];
        this.yCoefficients = [];
        this.randomizeAxes = axisRandomization;
        this.numAxes = numAxes;
        for (let i = 0; i < numAxes; i++) {
            this.offsets[i] = [];
            this.periods[i] = [...periods];
            this.weights[i] = [];
            this.speeds[i] = [];
        }
        this.speedRandomization = speedRandomization;
        this.speed = speed;
    }
    sample(x, z, focusedAxes) {
        //Delayed initialization
        if (this.offsets[0].length === 0) {
            for (let i = 0; i < this.numAxes; i++) {
                let angle = i * Math.PI / (this.numAxes);
                if (this.randomizeAxes)
                    angle += Math.random() * Math.PI / (2 * (this.numAxes));
                this.xCoefficients[i] = Math.cos(angle);
                this.yCoefficients[i] = Math.sin(angle);
                for (let j = 0; j < this.periods[i].length; j++) {
                    this.offsets[i].push(Math.random() * (20 / this.periods[i][j]));
                }
                let weightTotal = 0;
                for (let j = 0; j < this.periods[i].length; j++) {
                    this.periods[i][j] *= 1 + Math.random() * 0.2;
                    this.weights[i].push(1 / this.periods[i][j]);
                    weightTotal += 1 / this.periods[i][j];
                }
                for (let j = 0; j < this.periods[i].length; j++) {
                    this.weights[i][j] /= weightTotal;
                }
                for (let j = 0; j < this.periods[i].length; j++) {
                    if (this.speedRandomization)
                        this.speeds[i].push(this.speed * (0.7 + Math.random() * 0.6));
                    else
                        this.speeds[i].push(this.speed);
                    const factor = this.getNegation(i, j);
                    this.speeds[i][j] = this.speeds[i][j] * (factor);
                }
            }
        }
        //Actual sample value
        let total = 0;
        for (let i = 0; i < this.numAxes; i++) {
            for (let j = 0; j < this.offsets[i].length; j++) {
                if (focusedAxes === undefined || focusedAxes.includes(i))
                    total += Math.cos(((x * this.xCoefficients[i] + z * this.yCoefficients[i]) / this.periods[i][j]) + this.offsets[i][j])
                        * this.weights[i][j];
            }
        }
        const result = total / ((focusedAxes === undefined ? this.numAxes : focusedAxes.length));
        return result;
    }
    sampleSin(x, y) {
        let total = 0;
        for (let i = 0; i < this.numAxes; i++) {
            for (let j = 0; j < this.offsets[i].length; j++) {
                total += Math.sin(((x * this.xCoefficients[i] + y * this.yCoefficients[i]) / this.periods[i][j]) + this.offsets[i][j])
                    * this.weights[i][j];
            }
        }
        const result = total / (2 * this.numAxes) + 0.5;
        return result;
    }
    updateAxes(deltaTime) {
        for (let k = 0; k < this.offsets.length; k++) {
            for (let i = 0; i < this.offsets[k].length; i++) {
                this.offsets[k][i] += this.speeds[k][i] * deltaTime;
            }
        }
    }
    SetSpeed(newSpeed) {
        this.speed = newSpeed;
        //Deal with randomization here!
    }
    getNegation(i, j) {
        return ((i + j) % 2) * 2 - 1;
    }
}
//# sourceMappingURL=Sinusoid.js.map